import React, { Component } from 'react';

/* ATCO just uses the shared form component, so we're just rendering out
the shared form component */
import SearchFormCommon from './searchForm_common';
import SearchFormHeader from './components/searchFormHeader';

class SearchFormATCO extends Component {
    render() {
        return (
            <div> 
                <SearchFormHeader headerTitle="ATCO" formType={this.props.formType} />
                <SearchFormCommon {...this.props} />           
            </div>
        );
    }
}

export default SearchFormATCO;


// WEBPACK FOOTER //
// ./src/components/searchForm/searchForm_atco.js